unit UITypes;

interface

implementation

end.